// reactstrap components
import React from "react";

const HeadTable = () => {
  return (
    <thead className="thead-light">
      <tr>
        <th scope="col">Society Name</th>
        <th scope="col">Budget</th>
        <th scope="col">Admin</th>
        <th scope="col">Others</th>
        <th scope="col" />
      </tr>
    </thead>
  );
};

export default HeadTable;
